/**
 * @param date - The date to format
 * Returns a formatted date string at the user's browser timezone
 * e.g. "June 12, 2025 at 12:00 PM PDT"
 */
export function formatDateTimeWithTimezone(date: Date): string {
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    month: 'long',
    timeZoneName: 'short',
    year: 'numeric',
  })
}
